<template>
  <div
    class="popup-overlay"
    id="popup-overlay__country"
    :class="{ active: showSeclect }"
  >
    <div id="popup-content" class="popup-content">
      <button class="popup-close" @click="(e) => closePopup(e)">
        <img
          src="@/assets/images/currency-popup-close.svg"
          width="12"
          heigh="12"
          alt="close"

        />
      </button>
      <Heading style="margin-top: 0; margin-bottom: 10px" level="2"
        >I am shipping to</Heading
      >
      <div class="country-list">
        <ul style="padding: 0; background: #f3f3f3; margin: 0">
          <li
            @click="handleClick(country)"
            v-for="country in countries"
            :key="country.label"
            class="country-item"
            :class="{ active: isActive(country) }"
          >
            <div
              class="country-item__detail"
              :class="{
                active: isActive(country),
                default: country.label === 'Malaysia' && !countryActive,
              }"
            >
              <img :src="country.flag" :alt="country.label" />
              <span>{{ country.label }}</span>
              <p
                v-if="country.label === 'Singapore' && isActive(country)"
                class="altcs-currency-desc"
              >
                <img style="margin-right: 0" :src="infoSvg" height="13" />
                You will be redirected to SK Singapore website
              </p>
              <p
                v-else-if="country.label !== 'Malaysia' && isActive(country)"
                class="altcs-currency-desc"
              >
                <img style="margin-right: 0" :src="infoSvg" height="13" alt="info" />
                You will be redirected to SK International website
              </p>
            </div>
          </li>
        </ul>
      </div>
      <button class="cta-button" @click="(e) => takeMeThere(e)">
        TAKE ME THERE
      </button>
      <a href="#" class="stay-button" @click="(e) => stayHere(e)"
        >Stay on this website</a
      >
    </div>
  </div>
</template>

<script setup>
const currencyCountry = useCookie("altcs_detect_country");
const runtimeConfig = useRuntimeConfig();
const wooStore = useWooStore();
import { ref } from "vue";
import Heading from "../Heading.vue";
import { getMiniCart } from "@/assist/MiniCart";
const route = useRoute();
const search = route.query.s ?? "/";
const props = defineProps({
  dataCountry: Object,
  showSeclect: Boolean,
});

import infoSvg from "@/assets/images/info.svg";
import {
  toggleMenu,
  jumpItem,
  openSubItem,
  backMenu,
  closePopupSelectCountry,
  toggleMenuBottom,
  handleWindowSizeChange,
  shopPopupSelectCountry,
} from "@/assist/HeaderMobile";
const emit = defineEmits(["closePopup", "handleSetCountry"]);
const countryActive = ref("Malaysia");
const choseItem = ref();
const forceActive = ref(false);
const forceCountry = ref('');

//   const showPopup = ref(true);
// if (typeof currencyCountry.value !== "undefined") {
//  countryActive.value = currencyCountry.value;
// }

const handleClick = (item) => {

  forceActive.value = false;
  forceCountry.value = '';

  countryActive.value = item.label;
  choseItem.value = item;
};

const check_intl = ref(false);
const isActive = (country) => {
  if (forceActive.value && forceCountry.value && forceCountry.value.active) {
    if (country.country_short === 'MY' && check_intl.value) {
      return true;
    }
    return country.country_short === forceCountry.value.active;
  }

  return (
    countryActive.value === country.label || 
    (
      countryActive.value &&
      currencyCountry.value === country.country_short &&
      countryActive.value === country.country_short
    )
  );
}


const countries = ref();
const defaultCountries = {
  MY: {
    flag: `${runtimeConfig.public.BASE_URL}api/wp-content/themes/skjmy/modules/multi-currency/assets/img/flags/my.svg`,
    label: "Malaysia",
    country_short: "MY",
    currency: "MAY",
  },
  SG: {
    flag: `${runtimeConfig.public.BASE_URL}api/wp-content/themes/skjmy/modules/multi-currency/assets/img/flags/sg.svg`,
    label: "Singapore",
    country_short: "SG",
    currency: "SGD",
  },
  AU: {
    flag: `${runtimeConfig.public.BASE_URL}api/wp-content/themes/skjmy/modules/multi-currency/assets/img/flags/au.svg`,
    label: "Australia",
    country_short: "AU",
    currency: "AUD",
  },
  KH: {
    flag: `${runtimeConfig.public.BASE_URL}api/wp-content/themes/skjmy/modules/multi-currency/assets/img/flags/kh.svg`,
    label: "Cambodia",
    country_short: "KH",
    currency: "USD",
  },
  CA: {
    flag: `${runtimeConfig.public.BASE_URL}api/wp-content/themes/skjmy/modules/multi-currency/assets/img/flags/ca.svg`,
    label: "Canada",
    country_short: "CA",
    currency: "USD",
  },
  FR: {
    flag: `${runtimeConfig.public.BASE_URL}api/wp-content/themes/skjmy/modules/multi-currency/assets/img/flags/fr.svg`,
    label: "France",
    currency: "EUR",
    country_short: "FR",
  },
  DE: {
    flag: `${runtimeConfig.public.BASE_URL}api/wp-content/themes/skjmy/modules/multi-currency/assets/img/flags/de.svg`,
    label: "Germany",
    currency: "EUR",
    country_short: "DE",
  },
  HK: {
    flag: `${runtimeConfig.public.BASE_URL}api/wp-content/themes/skjmy/modules/multi-currency/assets/img/flags/hk.svg`,
    label: "Hong Kong",
    country_short: "HK",
    currency: "HKD",
  },
  ID: {
    flag: `${runtimeConfig.public.BASE_URL}api/wp-content/themes/skjmy/modules/multi-currency/assets/img/flags/id.svg`,
    label: "Indonesia",
    country_short: "ID",
    currency: "USD",
  },
  IT: {
    flag: `${runtimeConfig.public.BASE_URL}api/wp-content/themes/skjmy/modules/multi-currency/assets/img/flags/it.svg`,
    label: "Italy",
    currency: "EUR",
    country_short: "IT",
  },
  NL: {
    flag: `${runtimeConfig.public.BASE_URL}api/wp-content/themes/skjmy/modules/multi-currency/assets/img/flags/nl.svg`,
    label: "Netherlands",
    currency: "EUR",
    country_short: "NL",
  },
  NZ: {
    flag: `${runtimeConfig.public.BASE_URL}api/wp-content/themes/skjmy/modules/multi-currency/assets/img/flags/nz.svg`,
    label: "New Zealand",
    country_short: "NZ",
    currency: "NZD",
  },
  PH: {
    flag: `${runtimeConfig.public.BASE_URL}api/wp-content/themes/skjmy/modules/multi-currency/assets/img/flags/ph.svg`,
    label: "Philippines",
    country_short: "PH",
    currency: "USD",
  },
  TH: {
    flag: `${runtimeConfig.public.BASE_URL}api/wp-content/themes/skjmy/modules/multi-currency/assets/img/flags/th.svg`,
    label: "Thailand",
    country_short: "TH",
    currency: "USD",
  },
  GB: {
    flag: `${runtimeConfig.public.BASE_URL}api/wp-content/themes/skjmy/modules/multi-currency/assets/img/flags/gb.svg`,
    label: "United Kingdom (UK)",
    country_short: "GB",
    currency: "GBP",
  },
  US: {
    flag: `${runtimeConfig.public.BASE_URL}api/wp-content/themes/skjmy/modules/multi-currency/assets/img/flags/us.svg`,
    label: "United States (US)",
    country_short: "US",
    currency: "USD",
  },
  ROW: {
    flag: 'https://www.skjewellery.com.my/api/wp-content/themes/skjmy/modules/multi-currency/assets/img/flags/row.svg',
    label: "Rest Of The World",
    country_short: "ROW",
    currency: "USD",
  },
};
onMounted(() => {
  if (wooStore.countries) {
    countries.value = { ...defaultCountries, ...wooStore.countries };
  }

  forceActive.value = true;
  forceCountry.value = typeof wooStore.currentCountry === 'object'
  ? wooStore.currentCountry
  : { active: wooStore.currentCountry || 'MY' };

  const allCountries = Object.values(countries.value);
  const match = allCountries.find(
    country => country.country_short === forceCountry.value.active
  );

  if (match) {
    check_intl.value = false;
    countryActive.value = match.label;
    choseItem.value = match;
  } else if (countries.value['MY']) {
    check_intl.value = true;
    const rowCountry = countries.value['MY'];
    countryActive.value = rowCountry.label;
    choseItem.value = rowCountry;
  }
  scrollToActiveCountry();
});

const scrollToActiveCountry = () => {
  nextTick(() => {
    const activeCountry = document.querySelector('.country-item.active');
    if (activeCountry) {
      activeCountry.scrollIntoView({ 
        behavior: 'smooth',
        block: 'center'
      });
    }
  });
};
const closePopup = (e) => {
  emit("closePopup", e);
  
  closePopupSelectCountry();
};
watch(
  () => props.showSeclect,
  (newVal) => {
    if (newVal) {
      countryActive.value = "Malaysia";
      countries.value = Object.values({
        ...defaultCountries,
        ...wooStore.countries,
      });
    }
  },
  { immediate: true, deep: true }
);

const takeMeThere = (e) => {
  var path = window.location.pathname;
  // if (path === "/" && search !== "/") {
  // path = "/other";
  // }
  // if (path === "/") {
  // window.location.reload();
  // }
  // console.log("path", path);
  closePopupSelectCountry();
  getMiniCart();

  emit("handleSetCountry", choseItem.value);
  emit("closePopup", e);

};
const handleClickOutside = (event) => {
  if (props.showSeclect) {
    const selectElement = document.getElementById("popup-content");
    const button = document.querySelector(".alt-header-country-selector");
    const button2 =
      window.innerWidth < 768
        ? document.querySelector(".country-selector_mobile")
        : null;

    if (
      selectElement &&
      !selectElement.contains(event.target) &&
      button &&
      !button.contains(event.target) &&
      (!button2 || !button2.contains(event.target))
    ) {
      // console.log("closePopupSelectCountry");
      emit("closePopup", event);
      // closePopupSelectCountry();
      const malaysia = defaultCountries.MY;
      choseItem.value = malaysia;
    }
  }
};

onMounted(() => {
  // countryActive.value = "Malaysia";
  nextTick(() => {
    // if(props.showSeclect)
    document.addEventListener("click", handleClickOutside);
  });
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside);
});

const stayHere = (e) => {
  e.stopPropagation();
  emit("closePopup", e);
  closePopupSelectCountry();
  const malaysia = defaultCountries.MY;
  choseItem.value = malaysia;
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/menu/_country-setting.scss";
</style>